export const nationalities = [
  {
      "value": "AF",
      "label": "Afganistán"
  },
  {
      "value": "AL",
      "label": "Albania"
  },
  {
      "value": "DE",
      "label": "Alemania"
  },
  {
      "value": "AD",
      "label": "Andorra"
  },
  {
      "value": "AO",
      "label": "Angola"
  },
  {
      "value": "AI",
      "label": "Anguila"
  },
  {
      "value": "AG",
      "label": "Antigua y Barbuda"
  },
  {
      "value": "SA",
      "label": "Arabia Saudita"
  },
  {
      "value": "DZ",
      "label": "Argelia"
  },
  {
      "value": "AR",
      "label": "Argentina"
  },
  {
      "value": "AM",
      "label": "Armenia"
  },
  {
      "value": "AU",
      "label": "Australia"
  },
  {
      "value": "AT",
      "label": "Austria"
  },
  {
      "value": "AZ",
      "label": "Azerbaiyán"
  },
  {
      "value": "BS",
      "label": "Bahamas"
  },
  {
      "value": "BD",
      "label": "Bangladés"
  },
  {
      "value": "BB",
      "label": "Barbados"
  },
  {
      "value": "BH",
      "label": "Baréin"
  },
  {
      "value": "BZ",
      "label": "Belice"
  },
  {
      "value": "BJ",
      "label": "Benín"
  },
  {
      "value": "BM",
      "label": "Bermudas"
  },
  {
      "value": "BY",
      "label": "Bielorrusia"
  },
  {
      "value": "BO",
      "label": "Bolivia"
  },
  {
      "value": "BA",
      "label": "Bosnia y Herzegovina"
  },
  {
      "value": "BW",
      "label": "Botsuana"
  },
  {
      "value": "BR",
      "label": "Brasil"
  },
  {
      "value": "BN",
      "label": "Brunéi"
  },
  {
      "value": "BG",
      "label": "Bulgaria"
  },
  {
      "value": "BF",
      "label": "Burkina Faso"
  },
  {
      "value": "BI",
      "label": "Burundi"
  },
  {
      "value": "BT",
      "label": "Bután"
  },
  {
      "value": "BE",
      "label": "Bélgica"
  },
  {
      "value": "CV",
      "label": "Cabo Verde"
  },
  {
      "value": "KH",
      "label": "Camboya"
  },
  {
      "value": "CM",
      "label": "Camerún"
  },
  {
      "value": "CA",
      "label": "Canadá"
  },
  {
      "value": "QA",
      "label": "Catar"
  },
  {
      "value": "TD",
      "label": "Chad"
  },
  {
      "value": "CL",
      "label": "Chile"
  },
  {
      "value": "CN",
      "label": "China"
  },
  {
      "value": "CY",
      "label": "Chipre"
  },
  {
      "value": "VA",
      "label": "Ciudad del Vaticano"
  },
  {
      "value": "CO",
      "label": "Colombia"
  },
  {
      "value": "KM",
      "label": "Comoras"
  },
  {
      "value": "KP",
      "label": "Corea del Norte"
  },
  {
      "value": "KR",
      "label": "Corea del Sur"
  },
  {
      "value": "CR",
      "label": "Costa Rica"
  },
  {
      "value": "CI",
      "label": "Costa de Marfil"
  },
  {
      "value": "HR",
      "label": "Croacia"
  },
  {
      "value": "CU",
      "label": "Cuba"
  },
  {
      "value": "DK",
      "label": "Dinamarca"
  },
  {
      "value": "DM",
      "label": "Dominica"
  },
  {
      "value": "EC",
      "label": "Ecuador"
  },
  {
      "value": "EG",
      "label": "Egipto"
  },
  {
      "value": "SV",
      "label": "El Salvador"
  },
  {
      "value": "AE",
      "label": "Emiratos Árabes Unidos"
  },
  {
      "value": "ER",
      "label": "Eritrea"
  },
  {
      "value": "SK",
      "label": "Eslovaquia"
  },
  {
      "value": "SI",
      "label": "Eslovenia"
  },
  {
      "value": "ES",
      "label": "España"
  },
  {
      "value": "US",
      "label": "Estados Unidos"
  },
  {
      "value": "EE",
      "label": "Estonia"
  },
  {
      "value": "ET",
      "label": "Etiopía"
  },
  {
      "value": "PH",
      "label": "Filipinas"
  },
  {
      "value": "FI",
      "label": "Finlandia"
  },
  {
      "value": "FJ",
      "label": "Fiyi"
  },
  {
      "value": "FR",
      "label": "Francia"
  },
  {
      "value": "GA",
      "label": "Gabón"
  },
  {
      "value": "GM",
      "label": "Gambia"
  },
  {
      "value": "GE",
      "label": "Georgia"
  },
  {
      "value": "GH",
      "label": "Ghana"
  },
  {
      "value": "GD",
      "label": "Granada"
  },
  {
      "value": "GR",
      "label": "Grecia"
  },
  {
      "value": "GU",
      "label": "Guam"
  },
  {
      "value": "GT",
      "label": "Guatemala"
  },
  {
      "value": "GN",
      "label": "Guinea"
  },
  {
      "value": "GQ",
      "label": "Guinea Ecuatorial"
  },
  {
      "value": "GW",
      "label": "Guinea-Bisáu"
  },
  {
      "value": "GY",
      "label": "Guyana"
  },
  {
      "value": "HT",
      "label": "Haití"
  },
  {
      "value": "HN",
      "label": "Honduras"
  },
  {
      "value": "HU",
      "label": "Hungría"
  },
  {
      "value": "IN",
      "label": "India"
  },
  {
      "value": "ID",
      "label": "Indonesia"
  },
  {
      "value": "IQ",
      "label": "Irak"
  },
  {
      "value": "IE",
      "label": "Irlanda"
  },
  {
      "value": "IR",
      "label": "Irán"
  },
  {
      "value": "IM",
      "label": "Isla de Man"
  },
  {
      "value": "IS",
      "label": "Islandia"
  },
  {
      "value": "KY",
      "label": "Islas Caimán"
  },
  {
      "value": "CK",
      "label": "Islas Cook"
  },
  {
      "value": "FO",
      "label": "Islas Feroe"
  },
  {
      "value": "FK",
      "label": "Islas Malvinas"
  },
  {
      "value": "MP",
      "label": "Islas Marianas del Norte"
  },
  {
      "value": "MH",
      "label": "Islas Marshall"
  },
  {
      "value": "SB",
      "label": "Islas Salomón"
  },
  {
      "value": "TC",
      "label": "Islas Turcas y Caicos"
  },
  {
      "value": "VI",
      "label": "Islas Vírgenes de los Estados Unidos"
  },
  {
      "value": "IL",
      "label": "Israel"
  },
  {
      "value": "IT",
      "label": "Italia"
  },
  {
      "value": "JM",
      "label": "Jamaica"
  },
  {
      "value": "JP",
      "label": "Japón"
  },
  {
      "value": "JO",
      "label": "Jordania"
  },
  {
      "value": "KZ",
      "label": "Kazajistán"
  },
  {
      "value": "KE",
      "label": "Kenia"
  },
  {
      "value": "KG",
      "label": "Kirguistán"
  },
  {
      "value": "KI",
      "label": "Kiribati"
  },
  {
      "value": "KW",
      "label": "Kuwait"
  },
  {
      "value": "LA",
      "label": "Laos"
  },
  {
      "value": "LS",
      "label": "Lesoto"
  },
  {
      "value": "LV",
      "label": "Letonia"
  },
  {
      "value": "LR",
      "label": "Liberia"
  },
  {
      "value": "LY",
      "label": "Libia"
  },
  {
      "value": "LI",
      "label": "Liechtenstein"
  },
  {
      "value": "LT",
      "label": "Lituania"
  },
  {
      "value": "LU",
      "label": "Luxemburgo"
  },
  {
      "value": "LB",
      "label": "Líbano"
  },
  {
      "value": "MK",
      "label": "Macedonia"
  },
  {
      "value": "MG",
      "label": "Madagascar"
  },
  {
      "value": "MY",
      "label": "Malasia"
  },
  {
      "value": "MW",
      "label": "Malaui"
  },
  {
      "value": "MV",
      "label": "Maldivas"
  },
  {
      "value": "MT",
      "label": "Malta"
  },
  {
      "value": "ML",
      "label": "Malí"
  },
  {
      "value": "MA",
      "label": "Marruecos"
  },
  {
      "value": "MU",
      "label": "Mauricio"
  },
  {
      "value": "MR",
      "label": "Mauritania"
  },
  {
      "value": "FM",
      "label": "Micronesia"
  },
  {
      "value": "MD",
      "label": "Moldavia"
  },
  {
      "value": "MN",
      "label": "Mongolia"
  },
  {
      "value": "ME",
      "label": "Montenegro"
  },
  {
      "value": "MS",
      "label": "Montserrat"
  },
  {
      "value": "MZ",
      "label": "Mozambique"
  },
  {
      "value": "MM",
      "label": "Myanmar"
  },
  {
      "value": "MX",
      "label": "México"
  },
  {
      "value": "MC",
      "label": "Mónaco"
  },
  {
      "value": "NA",
      "label": "Namibia"
  },
  {
      "value": "NR",
      "label": "Nauru"
  },
  {
      "value": "NP",
      "label": "Nepal"
  },
  {
      "value": "NI",
      "label": "Nicaragua"
  },
  {
      "value": "NG",
      "label": "Nigeria"
  },
  {
      "value": "NU",
      "label": "Niue"
  },
  {
      "value": "NO",
      "label": "Noruega"
  },
  {
      "value": "NC",
      "label": "Nueva Caledonia"
  },
  {
      "value": "NZ",
      "label": "Nueva Zelanda"
  },
  {
      "value": "NE",
      "label": "Níger"
  },
  {
      "value": "OM",
      "label": "Omán"
  },
  {
      "value": "PK",
      "label": "Pakistán"
  },
  {
      "value": "PW",
      "label": "Palaos"
  },
  {
      "value": "PS",
      "label": "Palestina"
  },
  {
      "value": "PA",
      "label": "Panamá"
  },
  {
      "value": "PG",
      "label": "Papúa Nueva Guinea"
  },
  {
      "value": "PY",
      "label": "Paraguay"
  },
  {
      "value": "NL",
      "label": "Países Bajos"
  },
  {
      "value": "PE",
      "label": "Perú"
  },
  {
      "value": "PF",
      "label": "Polinesia Francesa"
  },
  {
      "value": "PL",
      "label": "Polonia"
  },
  {
      "value": "PT",
      "label": "Portugal"
  },
  {
      "value": "PR",
      "label": "Puerto Rico"
  },
  {
      "value": "GB",
      "label": "Reino Unido"
  },
  {
      "value": "CF",
      "label": "República Centroafricana"
  },
  {
      "value": "CZ",
      "label": "República Checa"
  },
  {
      "value": "CD",
      "label": "República Democrática del Congo"
  },
  {
      "value": "DO",
      "label": "República Dominicana"
  },
  {
      "value": "CG",
      "label": "República del Congo"
  },
  {
      "value": "EH",
      "label": "República Árabe Saharaui Democrática"
  },
  {
      "value": "RE",
      "label": "Reunión"
  },
  {
      "value": "RW",
      "label": "Ruanda"
  },
  {
      "value": "RO",
      "label": "Rumania"
  },
  {
      "value": "RU",
      "label": "Rusia"
  },
  {
      "value": "WS",
      "label": "Samoa"
  },
  {
      "value": "AS",
      "label": "Samoa Americana"
  },
  {
      "value": "KN",
      "label": "San Cristóbal y Nieves"
  },
  {
      "value": "SM",
      "label": "San Marino"
  },
  {
      "value": "VC",
      "label": "San Vicente y las Granadinas"
  },
  {
      "value": "SH",
      "label": "Santa Elena,Ascensión y Tristán de Acuña"
  },
  {
      "value": "LC",
      "label": "Santa Lucía"
  },
  {
      "value": "ST",
      "label": "Santo Tomé y Príncipe"
  },
  {
      "value": "SN",
      "label": "Senegal"
  },
  {
      "value": "RS",
      "label": "Serbia"
  },
  {
      "value": "SC",
      "label": "Seychelles"
  },
  {
      "value": "SL",
      "label": "Sierra Leona"
  },
  {
      "value": "SG",
      "label": "Singapur"
  },
  {
      "value": "SY",
      "label": "Siria"
  },
  {
      "value": "SO",
      "label": "Somalia"
  },
  {
      "value": "LK",
      "label": "Sri Lanka"
  },
  {
      "value": "SZ",
      "label": "Suazilandia"
  },
  {
      "value": "ZA",
      "label": "Sudáfrica"
  },
  {
      "value": "SD",
      "label": "Sudán"
  },
  {
      "value": "SS",
      "label": "Sudán del Sur"
  },
  {
      "value": "SE",
      "label": "Suecia"
  },
  {
      "value": "CH",
      "label": "Suiza"
  },
  {
      "value": "SR",
      "label": "Surinam"
  },
  {
      "value": "TH",
      "label": "Tailandia"
  },
  {
      "value": "TZ",
      "label": "Tanzania"
  },
  {
      "value": "TJ",
      "label": "Tayikistán"
  },
  {
      "value": "TL",
      "label": "Timor Oriental"
  },
  {
      "value": "TG",
      "label": "Togo"
  },
  {
      "value": "TK",
      "label": "Tokelau"
  },
  {
      "value": "TO",
      "label": "Tonga"
  },
  {
      "value": "TT",
      "label": "Trinidad y Tobago"
  },
  {
      "value": "TM",
      "label": "Turkmenistán"
  },
  {
      "value": "TR",
      "label": "Turquía"
  },
  {
      "value": "TV",
      "label": "Tuvalu"
  },
  {
      "value": "TN",
      "label": "Túnez"
  },
  {
      "value": "XK",
      "label": "UIT 383 Kosovo"
  },
  {
      "value": "UA",
      "label": "Ucrania"
  },
  {
      "value": "UG",
      "label": "Uganda"
  },
  {
      "value": "UY",
      "label": "Uruguay"
  },
  {
      "value": "UZ",
      "label": "Uzbekistán"
  },
  {
      "value": "VU",
      "label": "Vanuatu"
  },
  {
      "value": "VE",
      "label": "Venezuela"
  },
  {
      "value": "VN",
      "label": "Vietnam"
  },
  {
      "value": "YE",
      "label": "Yemen"
  },
  {
      "value": "DJ",
      "label": "Yibuti"
  },
  {
      "value": "ZM",
      "label": "Zambia"
  },
  {
      "value": "ZW",
      "label": "Zimbabue"
  }
]